import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
  const lightbox = GLightbox();
});
